export default "__VITE_ASSET__Ewosb1cJ__"